const data = [
  {
    img: "./images/offering1.png",
    title: "Connections",
    description:
      "Allows you to make connections with your respected teachers and peers, and to grow together as to excel in various activities.",
  },
  {
    img: "./images/offering2.png",
    title: "Event Manager",
    description:
      "Get notified whenever there is a new event in your university and get a chance to showcase your talent and enhance your skills for your future needs.",
  },
  {
    img: "./images/offering3.png",
    title: "Go-Collab",
    description:
      " Collaborate with your teachers, peers and  particate in there projects or ask them to particate in your project.",
  },
];

export default data;
